/**
 * Created by piotr.pozniak@thebeaverhead.com on 22/03/2023.
 */

export const CTA_OPTIONS_GOOGLE = [
  {
    label: "Open first URL from event's description",
    value: "linkFirst",
  },
  {
    label: "Open last URL from event's description",
    value: "linkLast",
  },
  {
    label: "Contact organizer",
    value: "organizer",
  },
];
